import React, { useState, useEffect, useContext, useMemo } from 'react'
import * as style from './Calendar.module.css'
import { themeDefaults } from './Defaults.jsx'


const pad = (n) => String(n).padStart(2, '0');
const yyyyMm = (d) => `${d.getFullYear()}-${pad(d.getMonth() + 1)}`;
const dateIso = (d) => `${d.getFullYear()}-${pad(d.getMonth() + 1)}-${pad(d.getDate())}`;

export const Calendar = ({ avail, days, onSetBookingData })=>{
  const [theme, setTheme] = useState(themeDefaults)
  const [cursorMonthIndex, setCursorMonthIndex] = useState(0); // 0..2
  const [calendarMeta, setCalendarMeta] = useState({});
  const [selectedDay, setSelectedDay] = useState(null);
  const [bookingData, setBookingData] = useState({ name: '', lastname: '', email: '', phone: '', company: '' });
  const [overlay, setOverlay] = useState("none");
  const [activeSlot, setActiveSlot] = useState(-1);
  const [slotsLoading, setSlotsLoading] = useState(false)
  const today = useMemo(() => new Date(), []);
  const viewMonth = useMemo(() => new Date(today.getFullYear(), today.getMonth() + cursorMonthIndex, 1), [today, cursorMonthIndex]);
  const [slots, setSlots] = useState([]);
 
  const key = yyyyMm(viewMonth);
  const disabledDays = calendarMeta[key] ? calendarMeta[key].disabledDays || [] : [];

   // calendar matrix
  const matrix = useMemo(() => {
    const year = viewMonth.getFullYear();
    const month = viewMonth.getMonth();
    const firstDow = new Date(year, month, 1).getDay(); // 0=Sun
    const daysInMonth = new Date(year, month + 1, 0).getDate();
    const rows = [];
    let week = new Array(7).fill(null);
    let dayCounter = 1;
    for (let i = 0; i < firstDow; i++) week[i] = null;
    for (let i = firstDow; i < 7; i++) week[i] = new Date(year, month, dayCounter++);
    rows.push(week);
    while (dayCounter <= daysInMonth) {
      week = new Array(7).fill(null);
      for (let i = 0; i < 7 && dayCounter <= daysInMonth; i++) {
        week[i] = new Date(year, month, dayCounter++);
      }
      rows.push(week);
    }
    return rows;
  }, [viewMonth]);

  const onPickSlot = (stime, sid) => {
    setBookingData((p) => ({ ...p, 'slot': stime, 'euuid': sid, 'date': dateIso(selectedDay) }));
    onSetBookingData(
      { ...bookingData,
        'euuid': sid,
        'slot': stime,
//        'date': dateIso(selectedDay),
        'date': selectedDay
      });
  };

  useEffect(() => {
    if (!selectedDay) return;
    setSlotsLoading(true);
    setSlots([]);
    try {
      const iso = dateIso(selectedDay);
      let sls = avail[iso]
      console.log(Object.entries(sls))
      if(sls){
        setSlots(avail[iso])
      } else {
        setSlots([])
      };
    } catch (err) {
      console.error('slots fetch error', err);
      setSlots([]);
    } finally {
      setSlotsLoading(false);
    }
  }, [selectedDay]);

  return(
    <>
            {/* Calendar section page 1 */}
              <div style={{ display: "flex", width: "100%", flexDirection: "column" }} >
                <div style={{ display: "flex", width: "100%", height: 'min-content', justifyContent: "space-between", alignItems: 'center' }}>
                  <span style={{ paddingLeft: "3%", fontWeight: "bold", fontSize: "2em" }}>
                    {viewMonth.toLocaleString(undefined, { month: "long", year: "numeric" })}
                  </span>

                  <div style={{ display: "flex", gap: 12, paddingRight: 5, height: 'min-content' }}>
                    <button onClick={() => setCursorMonthIndex((ci) => Math.max(0, ci - 1))} disabled={cursorMonthIndex <= 0} >
                      ‹  prev
                    </button>
                    <button onClick={() => setCursorMonthIndex((ci) => Math.min(2, ci + 1))} disabled={cursorMonthIndex >= 2} >
                      next ›
                    </button>
                  </div>
                </div>

                <div style={{ display: "flex" }}>
                  <div style={{ flex: 1 }}>
                    <div
                      style={{
                        display: "grid",
                        gridTemplateColumns: "repeat(7, 1fr)",
                        textAlign: "center",
                      }}
                    >
                      {["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"].map((d) => (
                        <div key={d}>{d}</div>
                      ))}
                    </div>

                    <div>
                      {matrix.map((week, wi) => (
                        <div
                          key={wi}
                          style={{
                            display: "grid",
                            gridTemplateColumns: "repeat(7, 1fr)",
                            marginTop: 6,
                          }}
                        >
                          {week.map((cell, ci) => {
                            if (!cell) return <div key={ci} style={{ padding: 8 }} />;
                            const day = cell.getDate();
                            const disabled =
                              !days.includes(dateIso(cell)) ||
                              cell < new Date(today.getFullYear(), today.getMonth(), today.getDate());
                            const isSelected =
                              selectedDay && dateIso(selectedDay) === dateIso(cell);

                            return (
                              <button
                                key={ci}
                                onClick={() => !disabled && setSelectedDay(cell)}
                                disabled={disabled}
                                style={{
                                  padding: 8,
                                  margin: 4,
                                  border: isSelected
                                    ? "2px inset #007bff"
                                    : "1px solid #ccc",
                                  borderRadius: 6,
                                  background: disabled ? "#f5f5f556" : isSelected ? "#262a53" : "#fff",
                                  color: isSelected ? "#ffa0a0" : "#262a53",
                                    cursor: disabled ? "not-allowed" : "pointer",
                                }}
                              >
                              <span>{day}</span>
                              </button>
                            );
                          })}
                        </div>
                      ))}
                    </div>
                  </div>
                </div>
              <div className={style.item} >
                <div style={{ display: "inline-flex", flexDirection: "column", padding: "3%" }}>
                  {selectedDay ? (
                    <div>
                        <p>
                          Available 30-min slots for {selectedDay.toDateString()}
                        </p>
                      { slotsLoading ? <></> :
                        Object.keys(slots).length ? (
                          <div
                            style={{
                              display: "flex",
                              height: "auto",
                              overflow: "auto",
                              flexFlow: "wrap",
                              gap: "10px",
                            }}
                          >
                            { Object.entries(slots).map((s, si) => (
                              <div key={s} style={{ marginBottom: 6 }}>
                                <button
                                  style={{
                                    width: "50px",
                                    height: "30px",
                                    backgroundColor:
                                      activeSlot !== si ? "inherit" : "#262a53",
                                    borderRadius: "6px",
                                    color: activeSlot !== si ? "inherit" : "#ffa0a0"
                                  }}
                                  onClick={() => {
                                    setActiveSlot(si);
                                    onPickSlot(s[0], s[1]);
                                  }}
                                >
                                  {s[0]}
                                </button>
                              </div>
                            ))}
                          </div>
                      ) : (
                        <p>No slots available</p>
                      )}
                    </div>
                  ) : (
                    <p>Select a day to see available timeslots</p>
                  )}
                </div>
              </div>
              </div>

</>
) };
